import React, { useEffect, useState } from "react";
import { Users } from "lucide-react";
import api from "../lib/api";

/** Render a private team image from an authenticated blob request. */
export default function PrivateTeamPhoto({ team, clubId, refreshVersion = 0, knownAbsent = false, onAvailabilityChange }) {
    const [objectUrl, setObjectUrl] = useState("");

    useEffect(() => {
        if (!team?.id || !clubId || knownAbsent) {
            setObjectUrl("");
            return undefined;
        }
        setObjectUrl("");
        let active = true;
        let createdUrl = "";
        api.get(`/teams/${team.id}/photo`, {
            params: { club_id: clubId },
            responseType: "blob",
        }).then((response) => {
            if (!active) return;
            createdUrl = URL.createObjectURL(response.data);
            setObjectUrl(createdUrl);
            onAvailabilityChange?.(team.id, true);
        }).catch(() => {
            if (active) {
                setObjectUrl("");
                onAvailabilityChange?.(team.id, false);
            }
        });
        return () => {
            active = false;
            if (createdUrl) URL.revokeObjectURL(createdUrl);
        };
    }, [clubId, team?.id, refreshVersion, knownAbsent, onAvailabilityChange]);

    return <div className="h-36 bg-slate-100 rounded-xl overflow-hidden mb-4 flex items-center justify-center">
        {objectUrl
            ? <img src={objectUrl} alt={team?.name || "Équipe"} className="w-full h-full object-cover" />
            : <Users className="w-10 h-10 text-slate-300" aria-label="Photo indisponible" />}
    </div>;
}
